import { lazy, Suspense } from 'react';
import { Redirect } from 'react-router-dom';

import { PageLoader } from '@crehana/compass.ui/v2';

import {
  history,
  Route,
  Router,
  Switch,
} from '@/shared/components/react-router-dom';

import { Home } from './pages/Home';
import { RootLayout } from './shared/layouts/RootLayout';

const CoursePlayer = lazy(
  () =>
    import(
      /* webpackChunkName: "course-player-app" */ './pages/Classroom/CoursePlayer'
    ),
);

const CourseDashboard = lazy(
  () =>
    import(
      /* webpackChunkName: "course-dashboard-app" */ './pages/Classroom/CourseDashboard'
    ),
);

function App() {
  return (
    <RootLayout>
      {/* It's required to wrap all your lazy-components in a Suspense. Otherwise react-router will thrown an error.*/}
      <Suspense fallback={<PageLoader />}>
        <Router history={history}>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/clases/v2/:courseId/player/:lectureId" exact>
              <CoursePlayer />
            </Route>
            <Route path="/clases/v2/:courseId/:section" exact>
              <CourseDashboard />
            </Route>
            <Redirect
              from="/clases/v2/:courseId/"
              to="/clases/v2/:courseId/detalle/"
            />
          </Switch>
        </Router>
      </Suspense>
    </RootLayout>
  );
}

export default App;
